export const version = require("../package.json").version;
